import { render, staticRenderFns } from "./CustRestaurant.vue?vue&type=template&id=025fc816&"
import script from "./CustRestaurant.vue?vue&type=script&lang=js&"
export * from "./CustRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports